<template lang='pug'>
i.svg-icon.svg-icon-trash
  svg(
    :fill='color'
    :width='`${size}px`'
    :height='`${size}px`'
    viewBox='0 0 100 100')

    path(d="M18.5,55.97c0-7,0-13.99,0-20.99c0-2.23,1.19-3.76,3.15-4.11c2.19-0.4,4.26,1.19,4.43,3.42c0.03,0.35,0.01,0.71,0.01,1.07 c0,13.67,0,27.33,0,41c0,4.43,3.12,7.58,7.53,7.58c10.17,0,20.34,0,30.5,0c4.36,0,7.5-3.15,7.5-7.52c0-13.84,0-27.69,0-41.53 c0-1.99,1.09-3.51,2.8-3.95c2.19-0.56,4.32,0.8,4.71,3.02c0.07,0.43,0.09,0.88,0.09,1.33c0,13.7,0.01,27.39,0,41.09 c0,7.54-5,13.57-12.4,14.93c-0.9,0.17-1.83,0.22-2.74,0.22c-10.17,0.02-20.34,0.02-30.5,0.01c-8.53-0.01-15.1-6.58-15.11-15.11 C18.49,69.6,18.5,62.79,18.5,55.97z")
    path(d="M33.71,19.39c0-2.44-0.01-4.74,0.01-7.05c0-0.53,0.01-1.08,0.15-1.58c0.45-1.66,1.88-2.74,3.72-2.74 c7.53-0.02,15.06-0.03,22.58,0c2.33,0.01,3.85,1.62,3.87,3.97c0.02,2.1,0,4.21,0.01,6.31c0,0.32,0,0.64,0,1.09c0.42,0,0.77,0,1.11,0 c4.56,0,9.13,0.01,13.69,0c1.21,0,2.3,0.29,3.13,1.2c1.07,1.18,1.37,2.55,0.76,4.03c-0.59,1.45-1.73,2.21-3.27,2.36 C79.25,27.01,79.05,27,78.84,27c-19.98,0-39.95,0-59.93,0c-2.35,0-4.02-1.4-4.18-3.48c-0.18-2.32,1.57-4.11,4.09-4.12 c4.56-0.01,9.13,0,13.69,0C32.86,19.39,33.21,19.39,33.71,19.39z M41.31,19.33c5.09,0,10.08,0,15.11,0c0-1.25,0-2.45,0-3.65 c-5.07,0-10.08,0-15.11,0C41.31,16.92,41.31,18.09,41.31,19.33z")
    path(d="M37.49,55.47c0-4.44-0.01-8.89,0.01-13.33c0.01-1.86,1.3-3.34,3.11-3.7c1.64-0.32,3.41,0.56,4.09,2.14 c0.24,0.56,0.37,1.2,0.38,1.81c0.02,8.71,0.03,17.42,0.01,26.13c0,2.36-1.65,4.04-3.84,4.02c-2.18-0.02-3.76-1.72-3.76-4.09 C37.49,64.12,37.49,59.8,37.49,55.47z")
    path(d="M60.26,55.45c0,4.41,0.01,8.83-0.01,13.24c-0.01,1.8-1.1,3.22-2.78,3.69c-1.63,0.46-3.4-0.18-4.21-1.66 c-0.35-0.65-0.58-1.45-0.58-2.19c-0.04-8.71-0.03-17.42-0.02-26.13c0-2.35,1.65-4.03,3.84-4.01c2.18,0.02,3.75,1.72,3.76,4.09 C60.27,46.8,60.26,51.13,60.26,55.45z")


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}
</script>